import React from "react";

export default function Nav() {
  return (
    <div class="fixed top-0 left-0 text-center w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg">
      Simple Todo Application with Redux
    </div>
  );
}
